import React, { useState } from 'react';
import { useStepsState, useStepsDisplay } from '../StepsSectionContext';
import Button from '../../../../components/parts/Button';
import CodeBlock from './CodeBlock';

const InlinePolicy = () => {
  // eslint-disable-next-line no-unused-vars
  const [stateData, setStateData] = useStepsState();
  // eslint-disable-next-line no-unused-vars
  const [stepsDisplay, setStepsDisplay] = useStepsDisplay();
  const [currentCopiedText, setCurrentCopiedText] = useState('');

  const onCopy = text => {
    setCurrentCopiedText(text);
    navigator.clipboard.writeText(text);
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const CopyBlock = props => (
    <div>
      <Button
        primary
        style={{ width: '157px' }}
        // eslint-disable-next-line react/destructuring-assignment
        onClick={() => props.onCopyCallback(props.text)}
      >
        { currentCopiedText === '' ? 'Copy To Clipboard' : 'Copied!' }
      </Button>
      {/* eslint-disable-next-line react/destructuring-assignment */}
      <CodeBlock code={props.text} height={270} />
    </div>
  );

  const renderInlinePolicy = () => {
    const text = Object.keys(stateData).length > 0
      ? `${stateData.platform_metadata.inline_policy}`
      : 'Waiting for initial steps to be completed...';

    return <CopyBlock text={text} onCopyCallback={onCopy} />;
  };

  return (
    <div>
      <div>
        {renderInlinePolicy()}
      </div>
    </div>
  );
};

export default InlinePolicy;
